export default "__VITE_ASSET__9d8ced48__"